import styled from 'styled-components'

export const TrifoldWrapper = styled.div`
  display: flex;
  width: 100%;
  @media only screen and (max-width: 950px) {
    display: block;
  }
`

export const TrifoldCard = styled.div`
  padding: 4rem 2rem;
  flex: 1;
  display: block;
  text-align: center;
  background-color: ${({ bgColor }) => bgColor};
  color: white;

  > h3 {
    font-size: 25px;
    margin: 5rem 1rem 2.4rem 1rem;
  }

  > p {
    font-size: 19px;
    max-width: ${({ subMax }) => (subMax ? subMax : '310px')};
    margin: 0 auto;
    line-height: 1.3;
  }
  > div > svg {
    width: 165px;
    height: 106px;
  }
`
